import { reactive } from 'vue'
import { api } from '@/services/api'

const features = reactive({
  googleCalendar: { enabled: true },
  whatsapp: { enabled: true }
})

let loadingPromise = null

function applyFeatures(data) {
  if (!data || typeof data !== 'object') return
  if (data.googleCalendar) features.googleCalendar = { ...features.googleCalendar, ...data.googleCalendar }
  if (data.whatsapp) features.whatsapp = { ...features.whatsapp, ...data.whatsapp }
}

export function isFeatureEnabled(feature) {
  return features[feature]?.enabled !== false
}

export async function loadPlatformFeatures(force = false) {
  if (!force && loadingPromise) return loadingPromise
  loadingPromise = api
    .get('/companies/features', true, { silentUpgrade: true })
    .then((response) => {
      applyFeatures(response?.data ?? response)
      return features
    })
    .catch(() => features)
    .finally(() => {
      loadingPromise = null
    })
  return loadingPromise
}

export function usePlatformFeatures() {
  return {
    features,
    isFeatureEnabled,
    loadPlatformFeatures
  }
}
